// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__EkjPa","requiredAsterisk":"Info_requiredAsterisk__1eP3k"};